import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IApiResponse } from "../../../utils/types/api-response";
import {
    IConfirmSchedulePayload,
    IUpdateSchedulePayload,
} from "../types/dashboard.types";
import {
    confirmSchedule,
    updateSchedule,
} from "../services/dashboard.services";

export function useConfirmSchedule() {
    interface ApiResponseData {
        confirmed_sessions: string[];
        unconfirmed_sessions: {
            session_id: string;
            error: string;
        }[];
    }

    return useMutation<
        IApiResponse<ApiResponseData>,
        AxiosError<IApiResponse<ApiResponseData>>,
        IConfirmSchedulePayload
    >({
        mutationKey: ["confirm-schedule"],
        mutationFn: (payload: IConfirmSchedulePayload) =>
            confirmSchedule(payload),
    });
}

export function useUpdateSchedule() {
    interface ApiResponseData {
        updated_sessions: string[];
        unupdated_sessions: {
            session_id: string;
            error: string;
        }[];
    }

    return useMutation<
        IApiResponse<ApiResponseData>,
        AxiosError<IApiResponse<ApiResponseData>>,
        IUpdateSchedulePayload
    >({
        mutationKey: ["update-schedule"],
        mutationFn: (payload: IUpdateSchedulePayload) =>
            updateSchedule(payload),
    });
}
